// lib
import classNames from 'classnames'
import * as React from 'react'

// interfaces
import { IProps as IItemSegmentIconProps } from 'src/components/item_segment/parts/segment_icon/segment_icon'

// components
import ItemSegmentBase, { BIG_ITEM_SEGMENT, itemSegmentCls } from 'src/components/item_segment/base/item_segment_base'
import ItemSegmentLink, { IProps as ILinkProps } from 'src/components/item_segment/base/item_segment_link'
import SegmentRightArrow from 'src/components/item_segment/parts/segment_right_arrow/segment_right_arrow'
import SegmentRoundIcon from 'src/components/item_segment/parts/segment_round_icon/segment_round_icon'
import SegmentText from 'src/components/item_segment/parts/segment_text/segment_text'

interface IProps {
  /** a font icon rendered in a round segment icon */
  icon?: IItemSegmentIconProps;
  /** a ready-made icon element, used instead of `icon` */
  iconElement?: React.ReactNode;
  label: string;
  navigation: ILinkProps;
  className?: string;
}

const cls = itemSegmentCls + 'share'

/*
  A Wrapper for ItemSegment for Share buttons
*/
const ShareItemSegment: React.FC<IProps> = ({ icon, iconElement, label, navigation, className }) => (
  <ItemSegmentBase className={classNames(cls, className)} height={BIG_ITEM_SEGMENT}>
    <ItemSegmentLink {...navigation}>
      {iconElement
        ? <div className={itemSegmentCls + 'round-icon'}>{iconElement}</div>
        : icon && <SegmentRoundIcon name={icon.name} backgroundColor={icon.color} isInverted isLightRadius={false}/>}

      <SegmentText label={label} labelSize='big'/>
      <SegmentRightArrow/>
    </ItemSegmentLink>
  </ItemSegmentBase>
)

export default ShareItemSegment
